import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { artikel1 } from '../markdown/artikel-1';
import { artikel2 } from '../markdown/artikel-2';
import { artikel3 } from '../markdown/artikel-3';
import { artikel4 } from '../markdown/artikel-4';
import { artikel5 } from '../markdown/artikel-5';
import { artikel6 } from '../markdown/artikel-6';
import rehypeRaw from 'rehype-raw';

export default function Artikel() {
  // State untuk menentukan apakah artikel lengkap ditampilkan
  const [selectedPost, setSelectedPost] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('Semua Kategori');
  const [isTopPostVisible, setIsTopPostVisible] = useState(true);

window.location.hash = '#kategori-artikel'; 
// Menunggu agar render selesai dan kemudian melakukan scroll
setTimeout(() => {
  const kategoriArtikelSection = document.getElementById('kategori-artikel');
  if (kategoriArtikelSection) {
    kategoriArtikelSection.scrollIntoView({ behavior: 'smooth' });
  }

}, 0); 

  const categories = [
    'Semua Kategori',
    'Haji',
    'Umrah',
    'Islam',
    'Cerita Perjalanan',
  ];

  const posts = [
    {
      id: 1,
      category: 'Islam',
      time: 'Oktober 12, 2021',
      title: 'ketentuan dam haji dan umroh, tunaikan agar ibadah maqbul!',
      image: './assets/img/artikel/artikel-2.jpg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content: artikel1,
    },
    {
      id: 2,
      category: 'Umrah',
      time: 'November 28, 2024',
      title:
        'cek musim di arab saudi! rekomendasi musim paling nyaman untuk umroh',
      image: './assets/img/artikel/artikel-1.jpg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content: artikel2,
    },
    {
      id: 3,
      category: 'Islam',
      time: 'November 22, 2024',
      title: 'sholat jamak, kemudahan saat dalam perjalanan!',
      image: './assets/img/artikel/artikel-3.jpeg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content: artikel3,
    },
    {
      id: 4,
      category: 'Islam',
      time: 'November 19, 2024',
      title: 'wajib tahu! ini dia tata cara shalat jenazah',
      image: './assets/img/artikel/artikel-4.jpeg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content: artikel4,
    },
    {
      id: 5,
      category: 'Umrah',
      time: 'Oktober 02, 2024',
      title: 'Larangan - larangan saat umrah',
      image: './assets/img/artikel/artikel-5.jpg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content: artikel5,
    },
    {
      id: 6,
      category: 'Islam',
      time: 'Mei 29, 2024',
      title: 'Keutamaan dan Manfaat Melaksanakan Ibadah Umrah',
      image: './assets/img/artikel/artikel-6.jpg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content: artikel6,
    },
  ];

  const topPost = [
    {
      id: 1,
      category: 'Islam',
      time: 'Oktober 12, 2021',
      title: 'ketentuan dam haji dan umroh, tunaikan agar ibadah maqbul!',
      image: './assets/img/artikel/pembuka-artikel/pembuka-artikel-1.jpg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content:
        'Dam adalah denda yang harus dibayar oleh jamaah haji atau umrah yang melanggar larangan selama ihram. Dam adalah denda yang harus dibayar oleh jamaah haji atau umrah yang melanggar larangan selama ihram.',
    },
    {
      id: 2,
      category: 'Umrah',
      time: 'November 28, 2024',
      title:
        'Cek Musim di Arab Saudi! Rekomendasi musim paling nyaman untuk umroh',
      image: './assets/img/artikel/pembuka-artikel/pembuka-artikel-2.jpg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content:
        'Akhir November hingga awal April biasanya musim dingin dan puncak musim dingin biasanya di bulan Desember dan Januari, sedangkan untuk musim panas dimulai dari awal Mei hingga akhir Agustus dan puncaknya musim panas berada di Musim haji dari bulan Juni sampai Juli.',
    },
    {
      id: 3,
      category: 'Islam',
      time: 'November 22, 2024',
      title: 'Sholat Jamak, Kemudahan Saat Dalam Perjalanan',
      image: './assets/img/artikel/pembuka-artikel/pembuka-artikel-3.jpeg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content:
        'Bagi umat Islam yang melakukan perjalanan jauh (minimal 82 km) ada rukhsah atau dispensasi dalam hal ibadah shalat, yaitu jamak. Shalat jamak adalah melaksanakan dua shalat fardhu dalam satu waktu.',
    },
    {
      id: 4,
      category: 'Islam',
      time: 'November 19, 2024',
      title: 'Wajib Tahu! Ini Dia Tata Cara Shalat Jenazah',
      image: './assets/img/artikel/pembuka-artikel/pembuka-artikel-4.jpeg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content:
        'Shalat jenazah adalah shalat yang dilakukan  untuk mendo’akan  seorang muslim atau muslimah yang telah meninggal dunia; baik dia laki-laki maupun perempuan; orang dewasa maupun anak-anak. Adapun, shalat jenazah hukumnya wajib kifayah, yakni kewajiban yang pelaksanaannya dapat tercukupi manakala telah ditunaikan oleh sebagian kaum muslimin.',
    },
    {
      id: 5,
      category: 'Umrah',
      time: 'Oktober 02, 2024',
      title: 'Larangan - Larangan Saat Umrah',
      image: './assets/img/artikel/pembuka-artikel/pembuka-artikel-5.jpg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content:
        'Larangan larangan umroh ini adalah hal yang sering banget luput dari perhatian para jamaah umroh ketika melaksanakan umroh atau ketika berihrom yaitu menghindari larangan atau sesuatu yang membatalkan ihrom atau umroh tersebut',
    },
    {
      id: 6,
      category: 'Umrah',
      time: 'Desember 29, 2023',
      title: 'Keutamaan dan Manfaat Melaksanakan Ibadah Umrah',
      image: './assets/img/artikel/pembuka-artikel/pembuka-artikel-6.jpg',
      profileImage: './assets/img/sanema-logo.jpg',
      profileName: 'Sanema Tour',
      content:
        'Ibadah Umrah merupakan salah satu bentuk ibadah dalam Islam yang memiliki keutamaan dan manfaat yang sangat besar bagi setiap muslim yang melaksanakannya. Ibadah Umrah merupakan salah satu bentuk ibadah dalam Islam yang memiliki keutamaan dan manfaat yang sangat besar bagi setiap muslim yang melaksanakannya.',
    },
  ];

  // Filter posts based on selected category
  const filteredPosts =
    selectedCategory === 'Semua Kategori'
      ? posts
      : posts.filter((post) => post.category === selectedCategory);

  // Fungsi untuk mengatur artikel yang dipilih
  const handleReadMore = (post) => {
    setSelectedPost(post);
    setIsTopPostVisible(false);
  };

  // Fungsi untuk kembali ke halaman daftar artikel
  const handleBack = () => {
    setSelectedPost(null);
    setIsTopPostVisible(true);
  };

  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated fadeInUp">
                Artikel
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Beranda</a>
                  </li>
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    Artikel
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* TOP POST Section */}
      <div className="container">
        {/* Wrap section and main with Fragment */}
        <>
          {isTopPostVisible && (
            <section id="top-post">
              <div className="container">
                <Swiper
                  slidesPerView={1} // Jumlah slide yang ditampilkan sekaligus
                  spaceBetween={50} // Jarak antar slide
                  loop={true} // Untuk loop slide secara otomatis
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  pagination={{ clickable: true }} // Menampilkan pagination
                  modules={[Autoplay]}
                >
                  {topPost.map((post) => (
                    <SwiperSlide key={post.id}>
                      <div className="wrapper">
                        <div className="left">
                          <img src={post.image} alt="Post" />
                        </div>
                        <div className="right">
                          <span className="time stabilo2">{post.time}</span>
                          <a
                            href="#"
                            className="link-post stabilo1"
                            style={{ textTransform: 'uppercase' }}
                            onClick={() => handleReadMore(post)} // Menampilkan artikel lengkap
                          >
                            {post.title}
                          </a>
                          <div className="profile">
                            <img
                              src={post.profileImage}
                              alt={post.profileName}
                            />
                            <span className="name stabilo1">
                              {post.profileName}
                            </span>
                          </div>
                          <p>{post.content}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </section>
          )}

          {/* Main Section */}
          <main>
            <div className="container">
              {!selectedPost ? (
                <>
                  {/* Daftar kategori */}
                  <ul className="categories" id='kategori-artikel'>
                    {categories.map((category, index) => (
                      <li key={index}>
                        <a
                          href="#"
                          className={
                            selectedCategory === category ? 'active' : ''
                          }
                          onClick={() => setSelectedCategory(category)}
                        >
                          {category}
                        </a>
                      </li>
                    ))}
                  </ul>

                  {/* Daftar artikel */}
                  <div className="content">
                    <div className="left">
                      {filteredPosts.map((post) => (
                        <div className="post" key={post.id}>
                          <div className="profile">
                            <img
                              src={post.profileImage}
                              alt={post.profileName}
                            />
                            <span className="name stabilo1">
                              {post.profileName}
                            </span>
                          </div>
                          <img src={post.image} alt="Post" />
                          <span className="time">{post.time}</span>
                          <a
                            href="#"
                            className="link-post"
                            style={{ textTransform: 'uppercase' }}
                            onClick={() => handleReadMore(post)} // Menampilkan artikel lengkap
                          >
                            {post.title}
                          </a>
                          <button
                            className="btn btn-primary"
                            onClick={() => handleReadMore(post)}
                          >
                            Baca Selengkapnya
                          </button>
                        </div>
                      ))}
                    </div>
                    <div className="right">
                      <form>
                        <h3 className="sub-title">Cari Artikel</h3>
                        <input type="text" placeholder="Cari..." />
                      </form>
                      <div>
                        <h3 className="sub-title">Ikuti Sosial Media Kami</h3>
                        <ul className="social-link">
                          <li>
                            <a href="https://web.facebook.com/sanema.sji?mibextid=ZbWKwL&_rdc=1&_rdr#">
                              <i className="fab fa-facebook"></i>
                            </a>
                          </li>
                          <li>
                            <a href="https://www.instagram.com/sanematour?igsh=YnlnOG41a3l0b3V5">
                              <i className="fab fa-instagram"></i>
                            </a>
                          </li>
                          <li>
                            <a
                              className="btn btn-social"
                              href="https://www.tiktok.com/@sanematour?_t=8o5ZZ5FHpkQ&_r=1"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                                width="18"
                                height="18"
                              >
                                <path
                                  className="icon-path"
                                  d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"
                                  style={{ fill: 'black' }}
                                />
                              </svg>
                            </a>
                          </li>
                          <li>
                            <a href="https://www.youtube.com/@sanematour?si=wHOPQjdhTXsNtrB8">
                              <i className="fab fa-youtube"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div>
                        <h3 className="sub-title">Artikel Terbaru</h3>
                        <ul className="posts">
                          <li>
                            <a
                              href="#"
                              className="post-item d-flex align-items-center mb-3"
                            >
                              <div className="image-wrapper mb-2">
                                <img
                                  src="./assets/img/artikel/latest-post/late-post-3.jpg"
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                              <span style={{ textTransform: 'uppercase' }}>
                                cek musim di arab saudi! rekomendasi musim
                                paling nyaman untuk umrah
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              className="post-item d-flex align-items-center mb-3"
                            >
                              <div className="image-wrapper mb-2">
                                <img
                                  src="./assets/img/artikel/latest-post/late-post-2.jpeg"
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                              <span style={{ textTransform: 'uppercase' }}>
                                wajib tahu! ini dia tata cara shalat jenazah
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              className="post-item d-flex align-items-center mb-3"
                            >
                              <div className="image-wrapper">
                                <img
                                  src="./assets/img/artikel/latest-post/late-post-1.jpg"
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                              <span style={{ textTransform: 'uppercase' }}>
                                larangan - larangan saat umroh
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                // Artikel lengkap yang sedang dibaca
                <div className="post-detail">
                  <div className="post">
                    <h2
                      style={{
                        color: 'black',
                        fontSize: '42px',
                        textTransform: 'capitalize',
                        marginBottom: '40px',
                      }}
                    >
                      {selectedPost.title}
                    </h2>
                    <div className="profile">
                      <img
                        src={selectedPost.profileImage}
                        alt={selectedPost.profileName}
                        className="profile-image"
                      />
                      <span className="name">{selectedPost.profileName}</span>
                    </div>
                    <img
                      src={selectedPost.image}
                      alt="Post"
                      className="post-image"
                    />
                    <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                      {selectedPost.content}
                    </ReactMarkdown>
                    <button className="btn btn-primary" onClick={handleBack}>
                      Kembali ke Artikel
                    </button>
                  </div>
                </div>
              )}
            </div>
          </main>
        </>
      </div>
    </div>
  );
}
